import Estancias from "./Estancias";
export default Estancias;